import { Shield, RefreshCw } from "lucide-react";
import { Link } from "react-router-dom";

export function EvergreenPromise({ showRoadmapLink = true }: { showRoadmapLink?: boolean }) {
  return (
    <div className="border-t border-border bg-primary/5 px-4 pt-10 pb-6">
      <div className="max-w-3xl mx-auto text-center space-y-4">
        <div className="flex items-center justify-center gap-2 text-primary">
          <Shield className="h-5 w-5" />
          <RefreshCw className="h-5 w-5" />
        </div>
        <h3 className="text-lg font-bold text-foreground">Evergreen Software Promise</h3>
        <p className="text-sm text-muted-foreground leading-relaxed">
          QuoteSendGo is actively developed and continuously updated. Your subscription includes access to all future versions, 
          improvements, and new features for the life of the product while your subscription remains active. We are committed to 
          long-term support, regular updates, and building the best platform for service businesses.
        </p>
        {showRoadmapLink && (
          <Link
            to="/roadmap/public"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary hover:text-primary/80 transition-colors underline underline-offset-4"
          >
            View our public roadmap →
          </Link>
        )}
      </div>
    </div>
  );
}
